@if (isFacelift) {
    <iui-modal-header>{{ 'Rx.Export' | translate }}</iui-modal-header>
    <iui-modal-content [gapMultiplier]="2">
        <form class="form-horizontal">
            <iui-select id="cadCamSystem-options" name="cadCamSystem" [label]="'Settings.CAD_CAM_System' | translate"
                [options]="cadCamSystemTypeOptions" [getOptionName]="getOptionName" [compareWith]="compareWith"
                [ngModel]="selectedCadCamSystemType" (ngModelChange)="onCadCamSystemChange($event)" [layerSet]="'set-02'">
            </iui-select>

            <iui-checkbox logChange [locationParentObject]="'RestoExportModal'" *ngIf="!disablePatientDetailsBySWOpiont"
                [id]="'restoExport-hidePatientName-checkbox'" [checked]="hidePatientName"
                [isDisabled]="hidePatientName === undefined"
                (changeEvent)="onHidePatientNameChanged($event.checked)">
                {{ 'Settings.HidePatientName' | translate }}
            </iui-checkbox>
        </form>
    </iui-modal-content>
    <iui-modal-footer>
        <ng-container ngProjectAs="[right-buttons]">
            <button iuiButton logClick [locationParentObject]="'RestoExportModal'" id="restoExport-cancel-btn"
                type="brand" emphasis="secondary" size="l" (click)="close()">
                {{ 'Rx.Cancel' | translate }}
            </button>
            <button iuiButton logClick [locationParentObject]="'RestoExportModal'" id="btn-export"
                type="brand" emphasis="primary" size="l" (click)="export()" [disabled]="!canExport()">
                {{ 'Rx.Export' | translate }}
            </button>
        </ng-container>
    </iui-modal-footer>
} @else {
    <tlk-modal-header header>
        <span class="modal-title">{{ 'Rx.Export' | translate }}</span>
        <button logClick id="restorativeExport-close-btn" type="button" class="close" (click)="close()" right-icon>
            <img src="assets/images/close.svg" width="32" height="32" alt="close" />
        </button>
    </tlk-modal-header>
    <tlk-modal-content content>
        <form class="form-horizontal">
            <tlk-select
                id="cadCamSystem-options"
                name="cadCamSystem"
                [label]="'Settings.CAD_CAM_System' | translate"
                [options]="cadCamSystemTypeOptions"
                [getOptionName]="getOptionName"
                [compareWith]="compareWith"
                [ngModel]="selectedCadCamSystemType"
                (ngModelChange)="onCadCamSystemChange($event)">
            </tlk-select>

            <div *ngIf="!disablePatientDetailsBySWOpiont">
                <tlk-checkbox [id]="'restoExport-hidePatientName-checkbox'"
                    logChange
                    [checked]="hidePatientName"
                    [isDisabled]="hidePatientName === undefined"
                    (changeEvent)="onHidePatientNameChanged($event.checked)">
                    {{'Settings.HidePatientName' | translate }}
                </tlk-checkbox>
            </div>
        </form>
    </tlk-modal-content>
    <tlk-modal-footer footer>
        <ng-container ngProjectAs="[right-buttons]">
            <button logClick id="restorativeExport-cancel-btn" type="button" class="btn btn-default restorativeExport-btn" (click)="close()">
                {{'Rx.Cancel' | translate }}
            </button>

            <button logClick id="btn-export" type="button" class="btn btn-primary restorativeExport-btn" (click)="export()" [disabled]="!canExport()">
                {{'Rx.Export' | translate }}
            </button>
        </ng-container>
    </tlk-modal-footer>
}
